export default __webpack_public_path__ + "static/photoelectric5-0d6bab2da8f7275750fbb86788f3a03b.png";